<template>
  <div class="card">
    <div class="card-header">
      <h2>Course Description</h2>
    </div>
    <div class="card-body">
      <div class="form-field full-width">
        <label for="description">Description (English) <span class="required">*</span></label>
        <QuillEditor 
          id="description"
          :modelValue="modelValue.description"
          @update:modelValue="updateField('description', $event)"
          placeholder="Enter course description"
          :minHeight="'200px'"
          theme="snow"
          :options="quillOptions"
          required
          class="english-editor"
        />
      </div>
      
      <div class="form-field full-width">
        <label for="description_ar">Description (Arabic) <span class="required">*</span></label>
        <QuillEditor 
          id="description_ar"
          :modelValue="modelValue.description_ar"
          @update:modelValue="updateField('description_ar', $event)"
          placeholder="أدخل وصف الدورة"
          theme="snow"
          dir="rtl"
          :minHeight="'200px'"
          :options="quillOptionsArabic"
          class="arabic-editor"
        />
      </div>
    </div>
  </div>
</template>

<script>
import QuillEditor from '@/components/QuillEditor.vue';

export default {
  name: 'CourseDescriptionCard',
  components: {
    QuillEditor
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      quillOptions: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'font': [] }],
            [{ 'align': [] }],
            ['clean']
          ]
        },
        placeholder: 'Enter course description...',
        theme: 'snow'
      },
      quillOptionsArabic: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'direction': 'rtl' }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'font': [] }],
            [{ 'align': ['', 'right', 'center'] }],
            ['clean']
          ],
          direction: 'rtl'
        },
        placeholder: 'أدخل وصف الدورة',
        theme: 'snow'
      }
    };
  },
  methods: {
    updateField(field, value) {
      this.$emit('update:modelValue', {
        ...this.modelValue,
        [field]: value
      });
    }
  }
};
</script>

<style scoped>
.card {
  background-color: white;
  border-radius: 0.75rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: box-shadow 0.2s ease;
}

.card:hover {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07);
}

.card-header {
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #e2e8f0;
}

.card-header h2 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
}

.card-body {
  padding: 1.5rem;
}

.form-field {
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;
}

.form-field.full-width {
  grid-column: 1 / -1;
}

.form-field label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #4b5563;
  margin-bottom: 0.5rem;
}

.required {
  color: #ef4444;
  margin-left: 2px;
}

/* Specific styling for the QuillEditor */
:deep(.english-editor .ql-editor) {
  color: #1e293b !important;
  font-size: 0.95rem !important;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;
}

:deep(.arabic-editor .ql-editor) {
  color: #1e293b !important;
  font-size: 0.95rem !important;
  font-family: 'Noto Sans Arabic', system-ui, -apple-system, sans-serif !important;
  text-align: right !important;
}

/* QuillEditor fixes to ensure text is visible */
:deep(.ql-editor) {
  min-height: 200px !important;
  color: #1e293b !important;
  font-size: 0.95rem !important;
}

:deep(.ql-editor p) {
  color: #1e293b !important;
}

:deep(.ql-toolbar) {
  border-radius: 0.375rem 0.375rem 0 0 !important;
  border-color: #d1d5db !important;
  background-color: #f9fafb !important;
}

:deep(.ql-container) {
  border-radius: 0 0 0.375rem 0.375rem !important;
  border-color: #d1d5db !important;
  background-color: white !important;
}

:deep(.ql-toolbar .ql-stroke) {
  stroke: #4b5563 !important;
}

:deep(.ql-toolbar .ql-fill) {
  fill: #4b5563 !important;
}

:deep(.ql-toolbar .ql-picker) {
  color: #4b5563 !important;
}
</style> 